import React from 'react';

export default function Index() {
    return <div />;
}



// WEBPACK FOOTER //
// ./programm/index.js